import { useCallback, useMemo, useState } from 'react';

import { shallowEqual } from 'react-redux';

import { useMultipleSelect } from 'components/modules/Insurance/hooks/useMultipleSelect';
import { selectDriver } from 'store/insuranceAnketa/selectors';

import {
  VALUES_STORE_FALLBACK,
  VALUES_STORE_MAP,
  VALUES_STORE_TRANSFORM,
} from '../DriverCard.constants';

export const useLocalState = ({ id }) => {
  const { values: state } = useMultipleSelect({
    fallback: VALUES_STORE_FALLBACK,
    map: VALUES_STORE_MAP,
    selector: selectDriver(id),
    transform: VALUES_STORE_TRANSFORM,
  });

  const [values, setValues] = useState(state);

  const stateDependencies = Object.values(state);
  const valuesDependencies = Object.values(values);

  const changed = useMemo(
    () => {
      return !shallowEqual(state, values);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...stateDependencies, ...valuesDependencies]
  );

  const onReset = useCallback(
    () => {
      setValues(state);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    stateDependencies
  );
  const onSetLocal = useCallback(({ key, value }) => {
    setValues((values) => {
      return { ...values, [key]: value };
    });
  }, []);

  return { changed, onReset, onSetLocal, values };
};
